import {
  Component, ElementRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {PortalService} from "../../services/portal/portal.service";

/**
 * Base component for portal components
 */
@Component({template: ''})
export class PortalBaseComponent implements OnInit, OnDestroy {

  // The formio component associated with the angular component, if any
  @Input()
  formioComponent: any;

  data: any = {};           // The data for display in the dynamic component
  parameters: any = {};     // The parameters for customising the dynamic component
  parametersJSON: any = {}; // The parameters for customising the dynamic component
  preview: boolean = false; // Whether the component is being displayed in the edit modal preview

  // Support allowing a portal component to override the configured height of a modal when that is not
  // wht is wanted, usually to allow the modal to fit the component exactly.
  modalHeight: string = null;

  // The function that retrieves the data if this is a database derived component.
  getData: (parameters: any, action?: string) => Promise<any>;

  // A function that receives a button click if the portal component is embedded in a modal and one of the modal
  // buttons is clicked. Return true if the modal should be closed, return false if it should not. If nothing is
  // returned then the modal is closed.
  click?(args: any): any;

  constructor(public portalService: PortalService, public hostElement: ElementRef) {
    this.init();
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.destroy();
  }

  init() {
    this.portalService.registerComponent(this);
  }

  destroy() {
    this.portalService.deregisterComponent(this);
  }

  // override this to have refresh in your component
  async refresh() {
    if (this.getData) {
      this.data = await this.getData(this.parameters);
    }
  }

  getPortalService(): PortalService {
    return this.portalService;
  }

  identifyComponent(): string {
    const name = (this as any).constructor.name;
    const parameters = this.parameters ? JSON.stringify(this.parameters) : this.parametersJSON;
    return `${name} ${parameters}`;
  }

  disableModalHeightSetting() {
    this.modalHeight = $("#default-portal-modal-dialog")[0].style.height;
    $("#default-portal-modal-dialog")[0].style.height = null;
  }

  enableModalHeightSetting() {
    $("#default-portal-modal-dialog")[0].style.height = this.modalHeight;
  }
}
